export enum AUTOCOMPLETE_TYPE {
  AIRPORT = 'iata_code',
  CITY = 'location_id',
  HOTEL_IDENTIFIER = 'identifier',
}

export function removeDuplicateAutocomplete(
  airports: any,
  type: AUTOCOMPLETE_TYPE
) {
  const uniqueAirports = new Map();
  airports.forEach((airport: any) => {
    if (!uniqueAirports.has(airport[type])) {
      uniqueAirports.set(airport[type], airport);
    } else if (
      uniqueAirports.has(airport[type]) && airport?.type === 'airport'
    ) {
      uniqueAirports.delete(airport[type]);
      uniqueAirports.set(airport[type], airport);
    }
  });

  return Array.from(uniqueAirports.values());
}
